const repeatTypes = {
  daily: [ '1', '2', '3', '4', '5', '6', '7' ],
  never: [ ],
  weekDays: [ '1', '2', '3', '4', '5' ],
  weekendDays: [ '6', '7' ],
};

export default repeatTypes;
